import { render, staticRenderFns } from "./ToggleButtonDapp.vue?vue&type=template&id=766afc86"
import script from "./ToggleButtonDapp.vue?vue&type=script&lang=ts"
export * from "./ToggleButtonDapp.vue?vue&type=script&lang=ts"
import style0 from "./ToggleButtonDapp.vue?vue&type=style&index=0&id=766afc86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports